import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoNovaUnidade'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetNovaUnidade = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetNovaUnidade`, data, config)
const GetEmpreendimentoNovaUnidadeByInsumos = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoNovaUnidadeByInsumos`, data, config)
const EmpreendimentoNovaUnidadeId = (EmpreendimentoNovaUnidadeId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/EmpreendimentoNovaUnidadeId/${EmpreendimentoNovaUnidadeId}`, data, config)
const GetEmpreendimentoNovaUnidade = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetEmpreendimentoNovaUnidade/?limit=${limit}&index=${index}`, data, config)
const UpdateApelido = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/UpdateApelido`, data, config)
const criacaoEmpreendimentonovaunidade = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/criacaoEmpreendimentonovaunidade`, data, config)
const UnidadeInativacao = (empreendimento, acao, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/UnidadeInativacao/${empreendimento}/${acao}`, config)

const EnterpriseNewUnit = {
  GetNovaUnidade,
  UpdateApelido,
  UnidadeInativacao,
  criacaoEmpreendimentonovaunidade,
  GetEmpreendimentoNovaUnidade,
  GetEmpreendimentoNovaUnidadeByInsumos,
  EmpreendimentoNovaUnidadeId
}

export default EnterpriseNewUnit



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/enterprisenewunit.js